import React from 'react';

const HelpPage = () => (
    <div>
        This will be the <strong>help</strong> component
    </div>
); 

export default HelpPage;